import React, { useState, useEffect } from "react";
import BiztranControlsFormik from "../../biztran_controls_formik/BiztranControlsFormik";
import { Grid } from "@material-ui/core";
import { Formik, Form } from "formik";
import { makeStyles } from "@material-ui/core/styles";
import AccessibilityNewIcon from "@material-ui/icons/AccessibilityNew";
import EditIcon from "@material-ui/icons/Edit";
import BiztranControls from "../../biztran_controls/BiztranControls";
// import ModalFrame from "../../biztran_controls/Modal_Frame";
import UseFetchData from "../../../hooks/UseFetchData";
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
//import Checkbox from "@material-ui/core";
// import Checkbox from "../../biztran_controls/Checkbox";
// import CheckboxesGroup from "../../biztran_controls/CheckboxGroup";
// import checkboxAdnRadioStyle from "../../../assets/jss/material-dashboard-react/checkboxAdnRadioStyle";
import Checkbox from "../../biztran_controls_formik/Checkbox";

const CreateSymptomMaster = (props) => {
    const [SrNo, setSrNo] = useState("");
    const [isOpen, setOpen] = useState(false);
    const [Remarks, setRemarks] = useState("");
    const [PocTestsMasterID, setPocTestsMasterID] = useState("");
    const [Features, setFeatures] = useState("");
    const [FeatureGroup, setFeatureGroup] = useState("");
    const [featuregrpcmb, setFeaturegrpcmb] = useState("");
    const [response, fetchData] = UseFetchData();
    const [onSubmit, setOnSubmit] = useState("");
    const [ShowInRegistration, setShowInRegistration] = useState("");
    const [IsActive, setIsActive] = useState("");
    const [Checkbox, setIsChecked] = useState("");

    return <div>
        <Formik initialValues={{}}
            // validationSchema={validationSchema}
            onSubmit={onSubmit}
             enableReinitialize>
            {formik => {
                return <Form>
                    <Grid spacing={1} container direction="row" >
                        <Grid item xs={12} container direction='row'>
                            <Grid item xs={2}>
                                <label
                                    htmlFor={"Symptom"}
                                    style={{

                                        width: "50",
                                    }}
                                >
                                    {"Symptom"}
                                </label>
                            </Grid>
                            <Grid item xs={6} width="10">
                                <BiztranControlsFormik
                                    control="input"
                                    type="text"
                                    name="Symptom"
                                    // ref={ref}
                                    value={SrNo}
                                    onChange={(e) => {
                                        setSrNo(e.target.value)
                                        // handleChange()
                                    }}
                                />
                            </Grid>
                        </Grid>

                        {/* <Checkbox {...ShowInRegistration} />
                        <Checkbox {...IsActive} /> */}
                        <Grid item xs={12}>
                            <div style={{ width: '100%' }}>
                                <div style={{ display: 'flex', justifyContent: 'center', alignContent: "center" }}>
                                    <BiztranControls.Button
                                        text="Update"
                                        type="submit"
                                        startIcon={<SaveIcon />}
                                    />
                                    <BiztranControls.Button
                                        text="Delete"
                                        type="delete"
                                        startIcon={<SaveIcon />}
                                    />
                                    <BiztranControls.Button
                                        text="CLOSE"
                                        startIcon={<CloseIcon />}
                                        onClick={() => { props.setOpen(false); }}
                                    />
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                </Form>

            }}

        </Formik>

    </div>


}
export default CreateSymptomMaster;
